<app-esqueleto-tableros [filterWidth]="200">
  <div titulo class="encabezadosSeparacion">
    <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal">
      <b>{{ "menu." + dataService.moduleSelect | translate }} </b>
    </span>
    <span class="w3-text-deep-orange">&bull;</span>
    <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal">
      {{ "menu." + dataService.subModuleSelect | translate }}
    </span>
  </div>
  <app-filters filtros
    [name]="'filtros.anio' | translate"
    [array]="yearsAvailable"
    [typeFilter]="Filters.YEAR"
    [click]="false"
    (eventClick)="yearChange($event)"
  ></app-filters>
  <app-filters filtros
    [name]="'filtros.mes' | translate"
    [array]="monthOfYearAvailable"
    [typeFilter]="Filters.MOUNTH"
    (eventClick)="monthChange($event)"
    [click]="false"
  ></app-filters>
  <app-filters filtros
    [name]="'filtros.region' | translate"
    [array]="zonas"
    [typeFilter]="Filters.SUCURSALES"
    [click]="false"
    [consolidado]="consolidadoZona"
    (eventClick)="zonaChange($event)"
  ></app-filters>
  <app-filters filtros
    [name]="'filtros.agencias' | translate"
    [array]="sucursales"
    [typeFilter]="Filters.SUCURSALES"
    [click]="false"
    [consolidado]="consolidado"
    (eventClick)="agencyChange($event)"
  ></app-filters>
  <div borrador class="borradorZona">
    <div class="w3-button w3-dropdown-click iconoBorrarFiltros" (click)="resetFilters()"
      matTooltip="{{'tooltips.borrar-filtros'|translate}}">
      <img src="./../../../../assets/img/eraser.png">
    </div>
    <mat-icon class="w3-button iconoMen iconoGris" [matMenuTriggerFor]="menu">
      more_vert
    </mat-icon>
    <mat-menu #menu="matMenu">
      <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportarPDF()">
        <mat-icon class="iconoGris">description</mat-icon>
        <span>{{'menu.Exportar'|translate}}</span>
      </button>
    </mat-menu>
  </div>
  <div contenido class="perfilContenido">
    @for (fila of filasGraficos; track $index) {
      <div class="w3-row filaGraficas">
        @for (g of fila; track g.zona) {
          <div class="zonaGraficas">
            <div class="grafica">
              <div class="tarjetaGrafica">
                <div class="headerGrafica">
                  <div class="tituloGrafica w3-titulo-contenidomenuSC">
                    <span class="w3-margin-left-contenido">{{ datosDe(g.zona, 'tituloZona') | translate }}</span>
                    @if (subtitles) {
                      <span class="w3-margin-left-contenido">&bull;</span>
                      <span class="w3-margin-left-filter w3-subtitulo" matTooltip="{{ subtitles }}">{{ subtitles }}</span>
                    }
                  </div>
                  <div class="iconosGrafica">
                    @if (g.type !== types.TABLE) {
                      <mat-icon class="iconoMen" (click)="g.etiquetas = !g.etiquetas"
                        matTooltip="{{ (g.etiquetas ? 'graf.desactivar' : 'graf.activar') | translate }}">
                        {{ g.etiquetas ? 'label_off' : 'label' }}
                      </mat-icon>
                    }
                    <mat-icon class="iconoMen" (click)="abrirModal(g)" matTooltip="{{ 'graf.ampliar' | translate }}">
                      zoom_out_map
                    </mat-icon>
                    <mat-icon class="iconoMen" [matMenuTriggerFor]="menuGrafico">more_vert</mat-icon>
                    <mat-menu #menuGrafico="matMenu">
                      <button mat-menu-item [matMenuTriggerFor]="menuTipos">
                        <mat-icon class="iconoGris">assessment</mat-icon>
                        <span>{{ 'graf.graficas' | translate }}</span>
                      </button>
                      @if (hayMasCategorias[g.zona - 1] && g.type !== types.TABLE) {
                        <button mat-menu-item (click)="mostrarTodo(g.zona)">
                          <mat-icon class="iconoGris">{{ verTodoActivo[g.zona - 1] ? 'visibility_off' : 'visibility' }}</mat-icon>
                          <span>{{ (verTodoActivo[g.zona - 1] ? 'graf.mostrar-principales' : 'graf.mostrar-todo') | translate }}</span>
                        </button>
                      }
                      <mat-divider></mat-divider>
                      <button mat-menu-item (click)="exportarGrafico(g)">
                        <mat-icon class="iconoGris">{{ g.type === types.TABLE ? 'description' : 'image' }}</mat-icon>
                        <span>{{ 'menu.Exportar' | translate }}</span>
                      </button>
                    </mat-menu>
                    <mat-menu #menuTipos="matMenu">
                      @for (tipo of g.tipos; track tipo) {
                        <button mat-menu-item (click)="cambiarTipo(g, tipo)" [disabled]="g.type === tipo">
                          <mat-icon class="iconoGris">{{ infoTipos[tipo].icono }}</mat-icon>
                          <span>{{ infoTipos[tipo].texto | translate }}</span>
                        </button>
                      }
                    </mat-menu>
                  </div>
                </div>
                <div class="contenidoGrafica">
                  @if (cargando[g.zona - 1]) {
                    @if (g.type === types.TABLE) {
                      <app-skeleton-table [filas]="8" [columnas]="3" />
                    } @else {
                      <app-skeleton-grafica />
                    }
                  } @else if (g.type !== types.TABLE) {
                    @if (datosDe(g.zona, 'data').length !== 0) {
                      <app-graficador
                        [zona]="g.zona * 10 + 1"
                        [data]="datosDe(g.zona, 'data')"
                        [labels]="datosDe(g.zona, 'labels')"
                        [type]="g.type"
                        [colors]="paleta"
                        [axisY]="datosDe(g.zona, 'axisY')"
                        [etiquetas]="g.etiquetas"
                        [distributed]="g.type === types.BAR || g.type === types.HEATMAP"
                        [altoEtiquetasX]="100"
                        [porcentaje]="true"
                        [agruparCategoriasExcedentes]="!verTodoActivo[g.zona - 1]"
                        [maxCategoriasVisibles]="maxCategoriasPorDefecto"
                        [etiquetaOtros]="'comercial.asosiatividad.perfil.otros' | translate"
                        (eventClick)="clickGrafic($event, g.zona)"
                      />
                    }
                  } @else {
                    <ng-container [ngTemplateOutlet]="tablaGrafico" [ngTemplateOutletContext]="{ zona: g.zona }" />
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</app-esqueleto-tableros>

@for (g of graficos; track g.zona) {
  <app-modal [isOpen]="g.ampliado" (close)="g.ampliado = false" [export]="true"
    [iconoExport]="g.type === types.TABLE ? 'description' : 'image'" (exportFile)="exportarGrafico(g)">
    <div modal-header>
      <span class="w3-titulo-contenidomenuSC">{{ datosDe(g.zona, 'tituloZona') | translate }}</span>
      @if (subtitles) {
        <span class="w3-margin-left-contenido w3-titulo-contenidomenuSC">&bull;</span>
        <span class="w3-margin-left-filter w3-subtitulo">{{ subtitles }}</span>
      }
    </div>
    <div modal-body>
      <div class="spaceGrafica">
        @if (g.type !== types.TABLE) {
          <div class="zonaGrafAmp">
            @if (g.ampliado) {
              <app-graficador
                [zona]="g.zona * 10 + 2"
                [data]="datosDe(g.zona, 'data')"
                [labels]="datosDe(g.zona, 'labels')"
                [type]="g.type"
                [colors]="paleta"
                [axisY]="datosDe(g.zona, 'axisY')"
                [etiquetas]="g.etiquetas"
                [distributed]="g.type === types.BAR || g.type === types.HEATMAP"
                [porcentaje]="true"
                [agruparCategoriasExcedentes]="!verTodoActivo[g.zona - 1]"
                [maxCategoriasVisibles]="maxCategoriasPorDefecto"
                [etiquetaOtros]="'comercial.asosiatividad.perfil.otros' | translate"
              />
            }
          </div>
        } @else {
          <ng-container [ngTemplateOutlet]="tablaGrafico" [ngTemplateOutletContext]="{ zona: g.zona }" />
        }
      </div>
    </div>
  </app-modal>
}

<ng-template #tablaGrafico let-zona="zona">
  @if (tablaZona[zona - 1]; as tabla) {
    <div class="w3-scroll tablaPerfil">
      <table class="w3-table borderInfLow">
        <thead>
          <tr class="w3-center w3-table-title">
            <th class="stikyColum w3-border-right-balance"></th>
            <th class="stikyColum w3-border-right-balance">{{ tabla.name }}</th>
            <th class="stikyColum w3-border-right-balance">%</th>
          </tr>
        </thead>
        <tbody>
          @for (label of datosDe(zona, 'labels'); track label; let i = $index) {
            <tr class="w3-table-trtd">
              <td class="borderAllLow">{{ label }}</td>
              <td class="borderAllLow alinRight marginDer">{{ tabla.valores[i] }}</td>
              <td class="borderAllLow alinRight marginDer">{{ tabla.porcentaje[i] }} %</td>
            </tr>
          }
          <tr class="w3-table-titleLow">
            <td class="borderAllLow">{{ 'comercial.asosiatividad.perfil.total' | translate }}</td>
            <td class="borderAllLow alinRight marginDer">{{ tabla.valores[tabla.valores.length - 1] }}</td>
            <td class="borderAllLow alinRight marginDer">{{ tabla.porcentaje[tabla.porcentaje.length - 1] }} %</td>
          </tr>
        </tbody>
      </table>
    </div>
  }
</ng-template>
